export function isError(currentLoad) {
    return {
      type: "SET_ERROR",
      payload: currentLoad
    };
  }
  